<template>
    <div class="relative">
       <div class="title tac mt50">
           <h4>{{typeText}}聚投账号</h4>
       </div>
        <div class="bind-form">
            <el-form ref="form" :rules="rules" :model="formItem" label-width="0px" size="large">
                <el-form-item prop="username">
                    <el-input v-model.trim="formItem.username" clearable placeholder="账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model.trim="formItem.password" placeholder="密码" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="submitLoading" @click="handleSubmit" class="full-w" round>{{typeText}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="bind-result tac" v-if="bindResult">
            <p>
                <span class="icon" :class="iconClass"></span>
            </p>
            <p class="mt20">
                {{typeText}}{{bindResult=='success'?'成功':'失败'}}
                <br><span style="color: #efefef;" @click="resetForm">关闭</span>
            </p>
        </div>
    </div>
</template>

<script>

    import API from '@/api/home';

    export default {
        name: "Bind.vue",
        data(){
            return{
                submitLoading:false,
                formItem:{
                    username:'',
                    password:'',
                },
                bindResult:'',
                rules:{
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码最短6位', trigger: 'blur' }
                    ],
                },
                openId:'',
                queryOperation:'',      // 1-绑定,2-解绑


            }
        },
        created(){
            this.openId = this.$route.query.a;
            this.queryOperation =  this.$route.query.b;
        },
        computed:{
            iconClass(){
                if(!this.bindResult){
                    return '';
                }else if(this.bindResult == 'success'){
                    return 'el-icon-success text-color-success';
                }else{
                    return 'el-icon-error text-color-error';
                }
            },
            typeText(){
                return this.queryOperation=='2'?'解除绑定':'绑定';
            }
        },
        methods:{
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(this.queryOperation!=='1'&this.queryOperation!=='2'){
                            return this.$message.error('参数有误，请重新尝试');
                        }

                        API.bindWeiXin({
                            username:this.formItem.username,
                            password:this.formItem.password,
                            open_id:this.openId,
                            type:this.queryOperation=='1'?'1':'2',
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.bindResult = 'success';
                            this.resetForm();
                        }, (err) => {
                            console.log('bindWeiXin error', err);
                            this.bindResult = '';
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(){
                this.bindResult = '';
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
        }

    }
</script>

<style scoped lang="scss">
    .bind-form{
        margin: 20px 50px;
    }
    ::v-deep .el-input__inner {
        border-radius: 23px;
        height: 45px;
    }

    .bind-result{
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #f7f8fa;
    }

    .icon{
        font-size: 70px;
    }

</style>
